import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import React from "react";
import { MisterIcon } from "@rtel/mister-icons";
import { Button } from "reactstrap";
import Modal from "src/components/Common/UI/Modal/Modal";
import CreateAtm from "./CreateAtm";
import EditAtm from "./EditAtm";
import DeleteAtm from "./DeleteAtm";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";
import { useAtmsDataViewLogic } from "./hooks/useAtmsDataViewLogic";
import { Navigate } from "react-router-dom";
import ReportDownload from "src/components/Common/UI/ReportDownload/ReportDownload";


const AtmsDataView = () => {

  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    t,
    modalEvent,
    apiTotalRecords,
    canDownloadExcel,
    downloadAnchorRef
  } = useAtmsDataViewLogic();

  const addAtmButton: React.FC = () => {
    return (
      <>
      <Button
        type="button"
        color="dark"
        onClick={ () => { actionEvent({action: "create"}); }}
        className="mb-1"
        size="sm"
        data-toggle="modal"
      >
        <MisterIcon name="Plus" size="sm" className="icon-light" /> {t(`Νέο ATM`)}
      </Button>

      <ReportDownload event={actionEvent} canDownloadCsv={false} canDownloadExcel={canDownloadExcel} />      
      </>
    )
  };

  const ActionButtons: React.FC = () => (
      <TableActionButtons event={actionEvent} canEdit={selectedRowsOfTable.length > 0} canDelete={selectedRowsOfTable.length > 0}  />
  );

  return (
    <>
        <a ref={downloadAnchorRef} href="#" style={{ display: 'none' }} />
        {loadingDone && (      
          <Table
              columns={columns}
              data={data}
              defaultOrderByKeyFilter={"id"}
              showNumberOfRows={true}
              rowSelection={true}
              setRowSelection={setSelectedRowsOfTable}
              multipleRowSelection={false}
              actionRowId={"id"}
              debugMode={false}
              noDataFoundTitle="No Atms yet"
              isChangeOrderOrVisibilityEnable={false}
              ButtonsAreaLeft={ActionButtons}
              ButtonsAreaRight={addAtmButton}
              hiddenColumnsForUser={["deleted", "id"]}
              textPosition="center"
              maxHeight="33rem"
              numberOfRows={apiTotalRecords}
              numberOfRowsTitle="ΑΤΜ"
              
          />
        )}

        <Modal
          isOpen={!!modalEvent.action}
          closeFilterModal={closeActionModal}
          title={getModalTitleByAction()}  
          size="xl"
          >
            {modalEvent.action === "create" && <CreateAtm handleCloseModal={closeActionModal}/> }
            {modalEvent.action === "edit" && <EditAtm handleCloseModal={closeActionModal} atmId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
            {modalEvent.action === "delete" && <DeleteAtm handleCloseModal={closeActionModal} atmId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
        </Modal>

        {!loadingDone && <LoadingSpinner />}
    </>
  )
}

export default AtmsDataView;

